import React from 'react';
import { componentService } from 'js/services/component.service';

export const SportsbookApp = React.lazy(() => import(/* webpackChunkName: "sportsbook-app" */ './SportsbookApp'));

componentService.registerPageComponents({ 'sportsbook-app': SportsbookApp });
// <hub2-sportsbook-app></hub2-sportsbook-app>
componentService.registerWebContentComponents({ SportsbookApp });

